// extracted by mini-css-extract-plugin
export default {"main":"ULmpX","container":"OrLK0","title":"vlZkI","titleThin":"TaB4s","mainScreen":"-FhvN","mainScreenImage":"IqhUi","mainScreenVideo":"QsD6W","skeleton-progress":"nxgKW"};